var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolIncidentManagement01 = function SvgSolIncidentManagement01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_incident_management-01_svg2__a",
    x1: 32.73,
    x2: 143.97,
    y1: 192.34,
    y2: 52.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__b",
    x1: 68.3,
    x2: 179.55,
    y1: 220.71,
    y2: 81.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__c",
    x1: 88.61,
    x2: 199.85,
    y1: 236.91,
    y2: 97.42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__d",
    x1: 2.2,
    x2: 113.45,
    y1: 167.99,
    y2: 28.51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__e",
    x1: 1.57,
    x2: 112.82,
    y1: 167.49,
    y2: 28.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__f",
    x1: 20.08,
    x2: 131.32,
    y1: 182.25,
    y2: 42.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__g",
    x1: 19.45,
    x2: 130.69,
    y1: 181.74,
    y2: 42.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__h",
    x1: 31.84,
    x2: 143.08,
    y1: 191.63,
    y2: 52.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__i",
    x1: 35.28,
    x2: 146.53,
    y1: 194.37,
    y2: 54.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__j",
    x1: -21.25,
    x2: 90,
    y1: 149.29,
    y2: 9.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__k",
    x1: -3.35,
    x2: 107.9,
    y1: 163.56,
    y2: 24.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_incident_management-01_svg2__a",
    id: "sol_incident_management-01_svg2__l",
    x1: 14.52,
    x2: 125.76,
    y1: 177.81,
    y2: 38.33
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m197.29 172.7-45.68-74.28c-2.57-4.2-6.79-7.13-11.63-8.06V33.35c-.01-9.2-7.47-16.65-16.66-16.66H95.73a6.62 6.62 0 0 0-5.74-3.33h-4.47C81.85 2.94 70.43-2.53 60.01 1.14c-5.71 2.01-10.2 6.5-12.22 12.22h-4.47c-2.37 0-4.56 1.28-5.74 3.33H16.66C7.47 16.7.01 24.16 0 33.35v139.98c.01 9.2 7.47 16.65 16.66 16.66h58.52c.15.31.28.64.45.94 3.06 5.61 8.96 9.09 15.35 9.06h91.35c6.39.02 12.27-3.45 15.33-9.06a17.84 17.84 0 0 0-.38-18.24ZM96.65 23.36h26.66c5.52 0 10 4.48 10 10v57.01c-2.4.46-4.67 1.41-6.67 2.81V36.69c0-3.68-2.98-6.67-6.67-6.67H96.64v-6.67Zm-53.32-3.34h7a3.33 3.33 0 0 0 3.27-2.67c1.47-7.21 8.52-11.87 15.73-10.39 5.23 1.07 9.32 5.16 10.39 10.39a3.34 3.34 0 0 0 3.27 2.67h7v13.33H43.33zm30.05 163.32H16.66c-5.52 0-10-4.48-10-10V33.35c0-5.52 4.48-10 10-10h20v6.67H20c-3.68 0-6.67 2.98-6.67 6.67v133.32c0 3.68 2.98 6.67 6.67 6.67h54.2c-.7 2.15-.97 4.41-.82 6.67ZM77.66 170H20V36.69h17.59a6.62 6.62 0 0 0 5.74 3.33h46.66c2.37 0 4.56-1.28 5.74-3.33h24.26v64.51zm114.19 17.69a10.8 10.8 0 0 1-9.52 5.64H90.99c-3.97.01-7.62-2.16-9.52-5.64-2.04-3.59-1.95-8.01.24-11.51l45.66-74.27c3.1-5.13 9.76-6.77 14.89-3.67 1.5.91 2.76 2.17 3.67 3.67l45.66 74.27c2.19 3.5 2.28 7.91.25 11.5Z",
    style: {
      fill: "url(#sol_incident_management-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 110.01c-5.52 0-10 4.48-10 10v30c0 5.52 4.48 10 10 10s10-4.48 10-10v-30c0-5.52-4.48-10-10-10m3.33 40c0 1.84-1.49 3.33-3.33 3.33s-3.33-1.49-3.33-3.33v-30c0-1.84 1.49-3.33 3.33-3.33s3.33 1.49 3.33 3.33z",
    style: {
      fill: "url(#sol_incident_management-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 166.67c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 13.33c-1.84 0-3.33-1.49-3.33-3.33s1.49-3.33 3.33-3.33 3.33 1.49 3.33 3.33-1.49 3.33-3.33 3.33",
    style: {
      fill: "url(#sol_incident_management-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.99 56.69H66.66c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h43.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#sol_incident_management-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66 76.68h20c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-20c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#sol_incident_management-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.99 93.35H66.66c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h43.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#sol_incident_management-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66 113.34h20c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-20c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#sol_incident_management-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.99 130.01H66.66c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h23.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#sol_incident_management-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.99 143.34H66.66c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h13.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#sol_incident_management-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.64 82.37c.62.63 1.47.98 2.36.98a3.327 3.327 0 0 0 2.98-1.84l13.33-26.66c.82-1.65.15-3.65-1.49-4.47a3.337 3.337 0 0 0-4.47 1.49L39.09 74.4l-3.4-3.4a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67Z",
    style: {
      fill: "url(#sol_incident_management-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.82 87.03a3.33 3.33 0 0 0-4.47 1.49l-11.26 22.53-3.4-3.4a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67c.62.63 1.47.98 2.36.98a3.327 3.327 0 0 0 2.98-1.84l13.33-26.66c.82-1.65.16-3.65-1.49-4.47Z",
    style: {
      fill: "url(#sol_incident_management-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.84 123.69s-.01 0-.02-.01a3.33 3.33 0 0 0-4.47 1.49L39.09 147.7l-3.4-3.4a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67c.62.63 1.47.99 2.36.99a3.327 3.327 0 0 0 2.98-1.84l13.33-26.66c.83-1.64.17-3.65-1.47-4.48Z",
    style: {
      fill: "url(#sol_incident_management-01_svg2__l)"
    }
  }));
};
export default SvgSolIncidentManagement01;